module.exports = __webpack_public_path__ + "img/header_bg_banner.dc6209dd.png";